import { render, staticRenderFns } from "./SelectView.vue?vue&type=template&id=bb7668ea&scoped=true"
import script from "./SelectView.vue?vue&type=script&lang=js"
export * from "./SelectView.vue?vue&type=script&lang=js"
import style0 from "./SelectView.vue?vue&type=style&index=0&id=bb7668ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7668ea",
  null
  
)

export default component.exports